import DynamicFeedbackInputFields from './DynamicFeedbackFields/DynamicFeedbackInputFields';

const StudentFeedback = () => {

    const studentFields = [
        { fieldName: 'name', customLabelName: "Name:", type: 'text', placeholder: 'Enter Your Name' },
        { fieldName: 'department', customLabelName: "Department:", type: 'text', placeholder: 'Enter Your Department' },
        { fieldName: 'email', customLabelName: "Email Address:", type: 'email', placeholder: 'Enter Your Email' },
        { fieldName: 'feedback', customLabelName: "Feedback:", type: 'textarea', placeholder: 'Enter Your Feedback' }
    ];

    return (
        <DynamicFeedbackInputFields
            title="Student's Feedback"
            fields={studentFields}
            formType="students"
        />
    )
}

export default StudentFeedback
